import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { CustomerInfo_$reflection, AccountInfo_$reflection, OrderedSparePart, SparePartOrder, SparePart_$reflection, SparePartOrder_$reflection } from "./Shared/ApiDataTypes.js";
import { record_type, int32_type, bool_type, obj_type, array_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { corsProps, testRedirect, extraCoders } from "./Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "./fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "./fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "./fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "./fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { value as value_133, some, unwrap, map, defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "./fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "./fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { numberHash, createObj, uncurry2 } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { ListItemText, ListItemIcon, ListItem, List, Skeleton, StepLabel, Step, Stepper, Collapse, Button, Autocomplete, Radio, FormControlLabel, RadioGroup, FormLabel, FormControl, Grid, TableFooter, TablePagination, Checkbox, TextField, IconButton, ButtonGroup, Typography, Alert, TableBody, TableRow, TableCell, TableHead, Table as Table_1 } from "@mui/material";
import { reactApi } from "./fable_modules/Feliz.2.8.0/Interop.fs.js";
import { sortByDescending, choose, append as append_1, collect, sumBy, pick, singleton as singleton_2, map as map_1 } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import { empty as empty_1, singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { compare, toShortDateString, now, minValue, toLongDateString } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { ctx as ctx_1 } from "./Context.js";
import { tryInt, useResponsive } from "./Utils.js";
import { defaultOf } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import ArrowDropUp from "@mui/icons-material/ArrowDropUp";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { parse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { condDisabledTooltip, onPageChange } from "./ViewHelpers.js";
import { Array_groupBy } from "./fable_modules/fable-library-js.4.24.0/Seq2.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.8.0/Internal.fs.js";
import { tryStr } from "./Shared/Shared.js";
import { API_Customer_Customer } from "./Shared/Urls.js";
import Check from "@mui/icons-material/Check";
import Clear from "@mui/icons-material/Clear";
import Sync from "@mui/icons-material/Sync";

function fetchSparePartOrders(machineId, callback) {
    let properties_2;
    const url = "/api/machine" + (`/${machineId}/spare-parts/orders`);
    let pr_2;
    let pr_1;
    const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(SparePartOrder_$reflection()), undefined, undefined);
    const data_1 = undefined;
    const caseStrategy_2 = undefined;
    const extra_2 = extraCoders;
    try {
        const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
            let response_1, decoder_1_1;
            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(SparePartOrder_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                let matchValue;
                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
        }))));
        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
    }
    catch (exn) {
        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
    }
    pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
    pr_2.then((_arg_2) => {
        if (_arg_2.tag === 1) {
            console.error(some(_arg_2.fields[0]));
        }
        else {
            callback(_arg_2.fields[0]);
        }
    });
}

export class SelectedItem extends Record {
    constructor(ManualInput, SelectedAmount, OrderedAmount, RemainingAmount, SparePart) {
        super();
        this.ManualInput = ManualInput;
        this.SelectedAmount = (SelectedAmount | 0);
        this.OrderedAmount = (OrderedAmount | 0);
        this.RemainingAmount = (RemainingAmount | 0);
        this.SparePart = SparePart;
    }
}

export function SelectedItem_$reflection() {
    return record_type("SpareParts.SelectedItem", [], SelectedItem, () => [["ManualInput", bool_type], ["SelectedAmount", int32_type], ["OrderedAmount", int32_type], ["RemainingAmount", int32_type], ["SparePart", SparePart_$reflection()]]);
}

export function toSelectedItem(sp) {
    return new SelectedItem(false, 0, 0, ~~sp.ItemCount, sp);
}

function selectedPartsTable(locale, selectedParts) {
    let elements_4, elements_2, children, elements_3;
    return MuiHelpers_createElement(Table_1, [["style", {
        width: 100 + "%",
    }], ["size", "small"], (elements_4 = [MuiHelpers_createElement(TableHead, [(elements_2 = [(children = ofArray([MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", locale.t("SparePart.PartNumber")]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", locale.t("SparePart.Description")]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["align", "right"], ["children", locale.t("SparePart.Amount")]])]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]), MuiHelpers_createElement(TableBody, [(elements_3 = [map_1((part) => {
        let elements;
        return MuiHelpers_createElement(TableRow, [(elements = [MuiHelpers_createElement(TableCell, [["children", part.SparePart.Code]]), MuiHelpers_createElement(TableCell, [["style", {
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
        }], ["children", part.SparePart.ProductDescription]]), MuiHelpers_createElement(TableCell, [["align", "right"], ["children", part.Amount]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    }, selectedParts)], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
}

function printOrder(locale, customerInfo, order) {
    const xs_10 = toList(delay(() => {
        let elems;
        return append(order.Cancelled ? singleton(MuiHelpers_createElement(Alert, [["severity", "error"], (elems = [createElement("p", {
            children: [locale.t("SparePart.OrderCancelled")],
        }), createElement("p", {
            children: [order.CancellationReason],
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])) : empty_1(), delay(() => {
            let elems_3, elems_1, elems_2;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                justifyContent: "space-between",
            }], (elems_3 = [createElement("p", createObj(singleton_1((elems_1 = [order.IncludeAssembly ? locale.t("SparePart.IncludeAssembly") : locale.t("SparePart.OnlyParts"), createElement("br", {}), order.RequestOffer ? locale.t("SparePart.RequestOffer") : locale.t("SparePart.OrderDirectly")], ["children", reactApi.Children.toArray(Array.from(elems_1))])))), createElement("p", createObj(singleton_1((elems_2 = [`Kundenr: ${customerInfo.Number}`, createElement("br", {}), `Kundenavn: ${customerInfo.Name}`, createElement("br", {}), `${locale.t("Ordered")} ${toLongDateString(order.Ordered)}`], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_4;
                return append(singleton(createElement("p", createObj(singleton_1((elems_4 = toList(delay(() => append(singleton(`${order.Account.Email}`), delay(() => append(singleton(createElement("br", {})), delay(() => append(singleton(`+${order.Account.PhoneCC} ${order.Account.Phone}`), delay(() => (!order.RequestOffer ? append(singleton(createElement("br", {})), delay(() => append(singleton(`${order.Address1}`), delay(() => append(singleton(createElement("br", {})), delay(() => singleton(`${order.PostalCode}, ${order.PostArea}`))))))) : empty_1()))))))))), ["children", reactApi.Children.toArray(Array.from(elems_4))]))))), delay(() => singleton(selectedPartsTable(locale, order.OrderedSpareParts))));
            }));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_10);
}

export function Table(tableInputProps) {
    let elements_11, th, elements_1, elements, elements_8, children_3, children_5, children_4;
    const setSelected = tableInputProps.setSelected;
    const selected = tableInputProps.selected;
    const searchTermOpt = tableInputProps.searchTermOpt;
    const readOnly = tableInputProps.readOnly;
    const ctx = reactApi.useContext(ctx_1);
    const responsive = useResponsive(undefined);
    const patternInput = reactApi.useState(0);
    const setPage = patternInput[1];
    const page = patternInput[0] | 0;
    const patternInput_1 = reactApi.useState(10);
    const rowsPerPage = patternInput_1[0] | 0;
    const isBig = (responsive === "wideScreen") ? true : (responsive === "desktop");
    const filtered = selected.filter((item) => defaultArg(map((term) => {
        const desc = item.SparePart.ProductDescription.trim().toLocaleLowerCase();
        const value = term.toLocaleLowerCase().trim();
        return desc.indexOf(value) >= 0;
    }, searchTermOpt), true));
    const rowsToSkip = (page * rowsPerPage) | 0;
    let rowsToTake;
    const nextTakeCount = (rowsToSkip + rowsPerPage) | 0;
    rowsToTake = ((filtered.length < nextTakeCount) ? (filtered.length - rowsToSkip) : rowsPerPage);
    const handleSelect = (_arg, itemId) => {
        setSelected(map_1((item_1) => {
            if (item_1.SparePart.Id === itemId) {
                return new SelectedItem(item_1.ManualInput, (item_1.SelectedAmount > 0) ? 0 : ((item_1.RemainingAmount <= 0) ? 1 : item_1.RemainingAmount), item_1.OrderedAmount, item_1.RemainingAmount, item_1.SparePart);
            }
            else {
                return item_1;
            }
        }, selected));
    };
    return MuiHelpers_createElement(Table_1, [(elements_11 = [(th = ((child) => MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", child]])), MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = toList(delay(() => append(!readOnly ? singleton(th(defaultOf())) : empty_1(), delay(() => append(singleton(th(MuiHelpers_createElement(Typography, [["children", !readOnly ? ctx.Locale.t("SparePart.Amount") : ctx.Locale.t("Ordered")]]))), delay(() => append(singleton(th(MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("SparePart.InStock")]]))), delay(() => append(singleton(th(MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("SparePart.Description")]]))), delay(() => (!readOnly ? singleton(th(MuiHelpers_createElement(Typography, [["children", ctx.Locale.t("SparePart.Chosen")]]))) : empty_1()))))))))))), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])), MuiHelpers_createElement(TableBody, [(elements_8 = ((selected.length === 0) ? singleton_2((children_3 = singleton_1(MuiHelpers_createElement(TableCell, [["colSpan", 5], ["style", {
        fontStyle: "italic",
        textAlign: "center",
    }], ["children", ctx.Locale.t("SparePart.NoSpareParts")]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_3))]]))) : map_1((selectedItem) => {
        let elements_4, elements_2, props_7, elements_3, props_10, elements_6;
        const td = (child_1) => MuiHelpers_createElement(TableCell, [["variant", "body"], ["children", child_1]]);
        const updateItem = (updateFn) => {
            setSelected(map_1((item_2) => {
                if (item_2.SparePart.Id === selectedItem.SparePart.Id) {
                    return updateFn(item_2);
                }
                else {
                    return item_2;
                }
            }, selected));
        };
        const selectAmountButtons = MuiHelpers_createElement(ButtonGroup, [["onClick", (ev) => {
            ev.stopPropagation();
        }], ["orientation", "horizontal"], ["size", "small"], (elements_4 = [MuiHelpers_createElement(IconButton, [["onClick", (ev_1) => {
            ev_1.stopPropagation();
            ev_1.preventDefault();
            updateItem((item_3) => (new SelectedItem(item_3.ManualInput, item_3.SelectedAmount + 1, item_3.OrderedAmount, item_3.RemainingAmount, item_3.SparePart)));
        }], ["size", "small"], (elements_2 = [(props_7 = {}, react.createElement(ArrowDropUp, props_7))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]), MuiHelpers_createElement(IconButton, [["onClick", (ev_2) => {
            ev_2.stopPropagation();
            ev_2.preventDefault();
            updateItem((item_4) => {
                const count$0027 = (item_4.SelectedAmount - 1) | 0;
                return new SelectedItem(item_4.ManualInput, (count$0027 < 0) ? 0 : count$0027, item_4.OrderedAmount, item_4.RemainingAmount, item_4.SparePart);
            });
        }], ["size", "small"], ["disabled", 0 === selectedItem.SelectedAmount], (elements_3 = [(props_10 = {}, react.createElement(ArrowDropDown, props_10))], ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
        return MuiHelpers_createElement(TableRow, [["key", selectedItem.SparePart.Id], ["style", createObj(toList(delay(() => (!readOnly ? singleton(["cursor", "pointer"]) : empty_1()))))], ["onClick", (ev_3) => {
            if (!readOnly) {
                handleSelect(ev_3, selectedItem.SparePart.Id);
            }
        }], ["hover", true], (elements_6 = toList(delay(() => append(!readOnly ? singleton(MuiHelpers_createElement(TableCell, [["padding", "checkbox"], ["variant", "body"], ["children", selectAmountButtons]])) : empty_1(), delay(() => {
            let elems_6;
            return append(singleton(td(MuiHelpers_createElement(Typography, [["variant", "h6"], (elems_6 = toList(delay(() => (readOnly ? singleton(createElement("span", {
                children: reactApi.Children.toArray([`${selectedItem.OrderedAmount}`]),
            })) : (selectedItem.ManualInput ? singleton(MuiHelpers_createElement(TextField, [["style", {
                width: 3 + "ch",
            }], ["onClick", (ev_4) => {
                ev_4.stopPropagation();
            }], ["onBlur", (_arg_1) => {
                let pr_1;
                const pr = new Promise(resolve => setTimeout(resolve, 50));
                pr_1 = (pr.then(() => {
                    updateItem((item_5) => (new SelectedItem(false, item_5.SelectedAmount, item_5.OrderedAmount, item_5.RemainingAmount, item_5.SparePart)));
                }));
                pr_1.then();
            }], ["onKeyPress", (ev_5) => {
                const elem = ev_5.target;
                if (ev_5.key === "Enter") {
                    updateItem((item_6) => (new SelectedItem(false, item_6.SelectedAmount, item_6.OrderedAmount, item_6.RemainingAmount, item_6.SparePart)));
                    elem.value = "";
                }
            }], ["autoFocus", true], ["size", "small"], ["onChange", (e_1) => {
                const amount = e_1.target.value;
                let newAmount;
                try {
                    newAmount = parse(amount, 511, false, 32);
                }
                catch (e) {
                    console.error(some(amount), "is not a number:", e);
                    newAmount = 0;
                }
                updateItem((item_7) => (new SelectedItem(item_7.ManualInput, newAmount, item_7.OrderedAmount, item_7.RemainingAmount, item_7.SparePart)));
            }]])) : singleton(createElement("span", {
                style: {
                    cursor: "pointer",
                    borderBottom: (((1 + "px ") + "dashed") + " ") + "#808080",
                },
                onClick: (ev_6) => {
                    ev_6.stopPropagation();
                    updateItem((item_8) => (new SelectedItem(!item_8.ManualInput, item_8.SelectedAmount, item_8.OrderedAmount, item_8.RemainingAmount, item_8.SparePart)));
                },
                children: `${selectedItem.SelectedAmount}`,
            })))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), delay(() => {
                let elems_7;
                return append(singleton(td(MuiHelpers_createElement(Typography, [(elems_7 = toList(delay(() => (readOnly ? singleton(createElement("span", {
                    children: [`${~~selectedItem.SparePart.ItemCount}`],
                })) : singleton(createElement("span", {
                    children: `${selectedItem.RemainingAmount}`,
                }))))), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))), delay(() => append(singleton(MuiHelpers_createElement(TableCell, [["style", {
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                }], ["children", selectedItem.SparePart.ProductDescription]])), delay(() => {
                    let children_2;
                    return !readOnly ? singleton((children_2 = singleton_1(MuiHelpers_createElement(Checkbox, [["color", "primary"], ["onChange", (ev_7) => {
                        handleSelect(ev_7, selectedItem.SparePart.Id);
                    }], ["checked", 0 < selectedItem.SelectedAmount]])), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_2))]]))) : empty_1();
                }))));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elements_6))])]);
    }, filtered.slice(rowsToSkip, (rowsToSkip + rowsToTake) + 1))), ["children", reactApi.Children.toArray(Array.from(elements_8))])]), (children_5 = singleton_1((children_4 = singleton_1(MuiHelpers_createElement(TablePagination, [["page", page], ["count", filtered.length], ["rowsPerPage", rowsPerPage], ["onPageChange", ((arg10$0040, newPage) => {
        onPageChange(setPage, arg10$0040, newPage);
    })], ["onRowsPerPageChange", (ev_8) => {
        const newRowsPerPage = ev_8.target.value | 0;
        setPage(0);
        patternInput_1[1](newRowsPerPage);
    }]])), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_4))]]))), MuiHelpers_createElement(TableFooter, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_11))])]);
}

export function WriteOrder(locale, order, setOrder) {
    let elems_6, elements_2, elements_1, elements, elements_3, elems_3, elements_4, elems_7;
    const orderForm = MuiHelpers_createElement(Grid, [["container", true], ["style", {
        padding: 15 + "px",
    }], (elems_6 = [MuiHelpers_createElement(Grid, [["item", true], ["xs", 3], (elements_2 = [MuiHelpers_createElement(FormControl, [(elements_1 = [MuiHelpers_createElement(FormLabel, [["children", locale.t("SparePart.Delivery")]]), MuiHelpers_createElement(RadioGroup, [["value", order.IncludeAssembly ? "assembly" : "parts"], ["onChange", (e) => {
        const _arg = e.target.value;
        switch (_arg) {
            case "parts": {
                setOrder(new SparePartOrder(order.Id, false, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
                break;
            }
            case "assembly": {
                setOrder(new SparePartOrder(order.Id, true, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
                break;
            }
            default:
                console.error(some("SpareParts.WriteOrder delivery radio group: invalid radio value!"));
        }
    }], (elements = [MuiHelpers_createElement(FormControlLabel, [["label", locale.t("SparePart.OnlyParts")], ["control", MuiHelpers_createElement(Radio, [["color", "primary"], ["value", "parts"]])]]), MuiHelpers_createElement(FormControlLabel, [["label", locale.t("SparePart.IncludeAssembly")], ["control", MuiHelpers_createElement(Radio, [["color", "primary"], ["value", "assembly"]])]])], ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elements_2))])]), MuiHelpers_createElement(Grid, [["item", true], ["xs", 9], (elements_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: 10 + "px",
        maxHeight: 100 + "px",
    }], (elems_3 = toList(delay(() => (order.RequestOffer ? append(singleton(MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", locale.t("SparePart.Offer")]])), delay(() => singleton(MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", locale.t("SparePart.OfferExplanation")]])))) : append(singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["label", locale.t("SparePart.Address1")], ["value", order.Address1], ["required", true], ["onChange", (e_1) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, e_1.target.value, order.Address2, order.PostalCode, order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
    }]])), delay(() => append(singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["label", locale.t("SparePart.Address2")], ["value", order.Address2], ["required", false], ["onChange", (e_2) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, e_2.target.value, order.PostalCode, order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
    }]])), delay(() => append(singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["label", locale.t("SparePart.PostCode")], ["required", true], ["defaultValue", undefined], ["onChange", (e_3) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, defaultArg(tryInt(e_3.target.value), -1), order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
    }]])), delay(() => append(singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["label", locale.t("SparePart.PostArea")], ["required", true], ["defaultValue", undefined], ["onChange", (e_4) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, e_4.target.value, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
    }]])), delay(() => singleton(MuiHelpers_createElement(TextField, [["size", "small"], ["label", locale.t("SparePart.Country")], ["required", true], ["value", order.Country], ["onChange", (e_5) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, order.PostArea, e_5.target.value, order.Ordered, order.Account, order.OrderedSpareParts));
    }]]))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]), MuiHelpers_createElement(Grid, [["item", true], ["xs", 12], (elements_4 = [MuiHelpers_createElement(TextField, [["fullWidth", true], ["label", locale.t("SparePart.Comment")], ["multiline", true], ["rows", 3], ["variant", "outlined"], ["onChange", (e_6) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, e_6.target.value, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
    }]])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elems_6))])]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_7 = [orderForm, selectedPartsTable(locale, order.OrderedSpareParts)], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

function emptyOrder(account) {
    return new SparePartOrder(-1, false, false, "", false, false, "", "", "", -1, "", "Norge", minValue(), account, []);
}

function collectOrderItems(orders) {
    return map_1((tupledArg) => {
        const osps = tupledArg[1];
        const sparePart = pick((osp_1) => osp_1.SparePart, osps);
        const totalAmount = sumBy((osp_2) => osp_2.Amount, osps, {
            GetZero: () => 0,
            Add: (x_1, y_1) => (x_1 + y_1),
        });
        const remaining = ~~(sparePart.ItemCount - totalAmount) | 0;
        return new SelectedItem(false, 0, ~~totalAmount, (remaining < 0) ? 0 : remaining, sparePart);
    }, Array_groupBy((osp) => osp.SparePart.Id, collect((o) => o.OrderedSpareParts, orders), {
        Equals: (x, y) => (x === y),
        GetHashCode: numberHash,
    }));
}

function CreateOrderView(createOrderViewInputProps) {
    let elems_1, elements_3, elements, elements_1, elements_2, elems_7;
    const setOrders = createOrderViewInputProps.setOrders;
    const orders = createOrderViewInputProps.orders;
    const machineInfo = createOrderViewInputProps.machineInfo;
    const customerInfo = createOrderViewInputProps.customerInfo;
    const account = createOrderViewInputProps.account;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const patternInput_1 = reactApi.useState(0);
    const setActiveStep = patternInput_1[1];
    const activeStep = patternInput_1[0] | 0;
    const patternInput_2 = reactApi.useState(false);
    const setCreateOrder = patternInput_2[1];
    const createOrder = patternInput_2[0];
    let patternInput_3;
    const initial_3 = emptyOrder(account);
    patternInput_3 = reactApi.useState(initial_3);
    const setOrder = patternInput_3[1];
    const order = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const patternInput_5 = reactApi.useState(new Array(0));
    const spareParts = patternInput_5[0];
    const setSpareParts = patternInput_5[1];
    let isCustomer;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const session = matchValue;
        isCustomer = (!session.IsAdmin && !session.IsPtg);
    }
    else {
        isCustomer = false;
    }
    const dependencies = [orders];
    reactApi.useEffect(() => {
        setSpareParts(collectOrderItems(orders));
    }, dependencies);
    useEffectOnce(() => {
        let properties_2;
        const url = "/api/machine" + (`/${machineInfo.Id}/spare-parts`);
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(SparePart_$reflection()), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(SparePart_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((_arg_2) => {
            if (_arg_2.tag === 0) {
                setSpareParts(append_1(spareParts, map_1((sp_1) => (new SelectedItem(false, 0, 0, ~~sp_1.ItemCount, sp_1)), _arg_2.fields[0].filter((spo) => !spareParts.some((sp) => (sp.SparePart.Id === spo.Id))))));
                patternInput[1](false);
            }
            else {
                console.error(some(_arg_2.fields[0]));
            }
        });
    });
    const orderInvalid = (!order.RequestOffer && (((order.Address1 === "") ? true : (order.PostalCode < 0)) ? true : (order.PostArea === ""))) ? true : (order.OrderedSpareParts.length === 0);
    const nextStepDisabled = ((activeStep === 0) && (spareParts.length === 0)) ? true : ((activeStep === 1) && orderInvalid);
    const resetOrder = () => {
        setOrder(emptyOrder(account));
        setCreateOrder(false);
        setActiveStep(0);
    };
    let reservePartAutocomplete;
    const show = !createOrder ? true : (activeStep === 0);
    reservePartAutocomplete = MuiHelpers_createElement(Autocomplete, [["style", createObj(toList(delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["maxWidth", 300]), delay(() => (!show ? singleton(["visibility", "hidden"]) : empty_1()))))))))], ["size", "small"], ["options", Array.from(spareParts)], ["getOptionLabel", (item_2) => item_2.SparePart.ProductDescription], ["freeSolo", true], ["onInputChange", (_arg_9, v, _arg_1_3) => {
        patternInput_4[1](tryStr(v));
    }], ["disableClearable", true], ["renderInput", (props) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(props), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["size", "small"]), delay(() => append(singleton(["color", "primary"]), delay(() => append(singleton(["label", ctx.Locale.t("Search")]), delay(() => singleton(["inputProps", createObj(toList(delay(() => append(Object.entries(props.inputProps), delay(() => singleton(["type", "search"]))))))]))))))))))))))]]);
    const xs_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 10 + "px",
    }], (elems_1 = toList(delay(() => append(singleton(createElement("div", {
        style: {
            flexGrow: 1,
        },
        children: reactApi.Children.toArray([reservePartAutocomplete]),
    })), delay(() => append(createOrder ? singleton(MuiHelpers_createElement(Button, [["onClick", (_arg_8) => {
        if (activeStep === 0) {
            resetOrder();
        }
        else {
            setActiveStep(activeStep - 1);
        }
    }], ["children", (activeStep === 0) ? ctx.Locale.t("Cancel") : ctx.Locale.t("Previous")]])) : append(singleton(MuiHelpers_createElement(Button, [["disabled", spareParts.length === 0], ["onClick", (_arg_10) => {
        setCreateOrder(!createOrder);
    }], ["children", createOrder ? ctx.Locale.t("Cancel") : ctx.Locale.t("SparePart.NewOrder")]])), delay(() => ((activeStep !== 2) ? singleton(MuiHelpers_createElement(Button, [["onClick", (_arg_11) => {
        setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, !order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, order.PostArea, order.Country, order.Ordered, order.Account, order.OrderedSpareParts));
        setCreateOrder(!createOrder);
    }], ["children", ctx.Locale.t("SparePart.RequestOffer")]])) : empty_1()))), delay(() => (createOrder ? ((activeStep === 2) ? singleton(condDisabledTooltip(ctx.Locale.t("SparePart.AdminCantOrder"), !isCustomer, MuiHelpers_createElement(Button, [["disabled", !isCustomer], ["style", {
        width: 9 + "em",
    }], ["onClick", (_arg_3) => {
        let properties_6;
        const url_4 = "/api/machine" + (`/${machineInfo.Id}/spare-parts/orders`);
        let pr_4;
        const item = new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1, order.Address2, order.PostalCode, order.PostArea, order.Country, now(), order.Account, order.OrderedSpareParts);
        const body_2 = Auto_generateBoxedEncoder_437914C6(SparePartOrder_$reflection(), undefined, undefined, undefined)(item);
        const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(SparePartOrder_$reflection(), undefined, undefined);
        const data_5 = some(body_2);
        const caseStrategy_11 = undefined;
        const extra_11 = undefined;
        try {
            const properties_3_1 = Helper_withProperties(corsProps, (properties_6 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_11), unwrap(extra_11))(data_1_2))]), properties_6), data_5), properties_6)));
            const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url_4, properties_3_1).then((_arg_4) => {
                let response_3, decoder_1_2;
                return ((response_3 = _arg_4, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(SparePartOrder_$reflection(), unwrap(caseStrategy_11), unwrap(extra_11))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_5) => {
                    let matchValue_2;
                    return Promise.resolve((matchValue_2 = fromString(uncurry2(decoder_1_2), _arg_5), (matchValue_2.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_2.fields[0]])])) : (new FSharpResult$2(0, [matchValue_2.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
            }))));
            pr_4 = (pr_3.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn_1) {
            pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
        }
        pr_4.then((_arg_6) => {
            if (_arg_6.tag === 0) {
                setOrders(append_1(orders, singleton_2(_arg_6.fields[0])));
                resetOrder();
            }
            else {
                console.error(some("Failed posting new spare parts order: "), _arg_6.fields[0]);
            }
        });
        if (isCustomer) {
            console.error(some("You are a customer, how nice"));
        }
        else {
            console.error(some("You must be logged in to place an order"));
        }
    }], ["children", ctx.Locale.t("Order")]]))) : singleton(MuiHelpers_createElement(Button, [["disabled", nextStepDisabled], ["style", {
        width: 9 + "em",
    }], ["onClick", (_arg_7) => {
        const newStep = (activeStep + 1) | 0;
        if (newStep === 1) {
            const selectedParts = choose((sp_2) => {
                if (sp_2.SelectedAmount === 0) {
                    return undefined;
                }
                else {
                    return new OrderedSparePart(sp_2.SelectedAmount, sp_2.SparePart);
                }
            }, spareParts);
            setOrder(new SparePartOrder(order.Id, order.IncludeAssembly, order.RequestOffer, order.Comment, order.Complete, order.Cancelled, order.CancellationReason, order.Address1.trim(), order.Address2.trim(), order.PostalCode, order.PostArea.trim(), order.Country, now(), order.Account, selectedParts));
        }
        setActiveStep(newStep);
    }], ["children", ctx.Locale.t("Next")]]))) : empty_1()))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), MuiHelpers_createElement(Collapse, [["in", createOrder], ["children", MuiHelpers_createElement(Stepper, [["activeStep", activeStep], (elements_3 = [MuiHelpers_createElement(Step, [["key", ctx.Locale.t("SparePart.ChooseSpareParts")], (elements = [MuiHelpers_createElement(StepLabel, [["children", ctx.Locale.t("SparePart.ChooseSpareParts")]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Step, [["key", ctx.Locale.t("SparePart.CreateOrder")], (elements_1 = [MuiHelpers_createElement(StepLabel, [["children", ctx.Locale.t("SparePart.CreateOrder")]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(Step, [["key", ctx.Locale.t("SparePart.ConfirmAndSendOrder")], (elements_2 = [MuiHelpers_createElement(StepLabel, [["children", ctx.Locale.t("SparePart.ConfirmAndSendOrder")]])], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])])]]), createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 0 + "%",
        paddingLeft: 15 + "px",
    }], (elems_7 = toList(delay(() => {
        let elems_6;
        if (patternInput[0]) {
            return singleton(MuiHelpers_createElement(Skeleton, [["height", 100 + "%"]]));
        }
        else {
            const matchValue_3 = activeStep | 0;
            switch (matchValue_3) {
                case 0:
                    return singleton(createElement(Table, {
                        readOnly: !createOrder,
                        searchTermOpt: unwrap(patternInput_4[0]),
                        selected: spareParts,
                        setSelected: setSpareParts,
                    }));
                case 1:
                    return singleton(WriteOrder(ctx.Locale, order, setOrder));
                case 2:
                    return singleton(createElement("div", createObj(ofArray([["style", {
                        flexGrow: 1,
                    }], (elems_6 = [printOrder(ctx.Locale, customerInfo, order)], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
                default: {
                    console.error(some("Something went wrong. Try again later"));
                    return singleton(createElement("span", {
                        children: ["Noe gikk galt! Prøv igjen senere."],
                    }));
                }
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))];
    return react.createElement(react.Fragment, {}, ...xs_4);
}

export function OrderView(machineInfo) {
    let elements_2, elems_7;
    const ctx = reactApi.useContext(ctx_1);
    const responsive = useResponsive(undefined);
    const isBig = (responsive === "wideScreen") ? true : (responsive === "desktop");
    const patternInput = reactApi.useState(true);
    const setLoadingOrders = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const setOrders = patternInput_1[1];
    const orders = patternInput_1[0];
    let patternInput_2;
    const initial_2 = !isBig;
    patternInput_2 = reactApi.useState(initial_2);
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedOrder = patternInput_3[1];
    const selectedOrder = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const accountOpt = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const customerOpt = patternInput_5[0];
    const loading = (patternInput[0] ? true : (accountOpt == null)) ? true : (customerOpt == null);
    const dependencies = [machineInfo];
    reactApi.useEffect(() => {
        setLoadingOrders(true);
        fetchSparePartOrders(machineInfo.Id, (sparePartOrders) => {
            setOrders(sparePartOrders);
            setLoadingOrders(false);
            if (sparePartOrders.length === 0) {
                patternInput_2[1](true);
            }
        });
    }, dependencies);
    useEffectOnce(() => {
        let properties_2;
        let pr_2;
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(AccountInfo_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = extraCoders;
        try {
            const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch("/api/account/me", properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(AccountInfo_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
        pr_2.then((_arg_2) => {
            if (_arg_2.tag === 0) {
                patternInput_4[1](_arg_2.fields[0]);
            }
            else {
                console.error(some("Failed fetching account info"), _arg_2.fields[0]);
            }
        });
    });
    useEffectOnce(() => {
        let properties_6;
        const url_3 = API_Customer_Customer(machineInfo.CustomerId);
        let pr_5;
        let pr_4;
        const decoder_3 = Auto_generateBoxedDecoder_Z6670B51(CustomerInfo_$reflection(), undefined, undefined);
        const data_5 = undefined;
        const caseStrategy_10 = undefined;
        const extra_10 = extraCoders;
        try {
            const properties_3_1 = Helper_withProperties(undefined, (properties_6 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_5, empty()), 0)])]), defaultArg(map((data_1_2) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_10), unwrap(extra_10))(data_1_2))]), properties_6), data_5), properties_6)));
            const pr_3 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url_3, properties_3_1).then((_arg_3) => {
                let response_3, decoder_1_2;
                return ((response_3 = _arg_3, (decoder_1_2 = defaultArg(decoder_3, Auto_generateBoxedDecoderCached_Z6670B51(CustomerInfo_$reflection(), unwrap(caseStrategy_10), unwrap(extra_10))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_3.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_3.text().then((_arg_4) => {
                    let matchValue_1;
                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_2), _arg_4), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_3])])))).then((_arg_1_2) => (Promise.resolve(_arg_1_2)))))))));
            }))));
            pr_4 = (pr_3.then(void 0, ((arg_1) => (new FSharpResult$2(1, [new FetchError(3, [arg_1])])))));
        }
        catch (exn_1) {
            pr_4 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn_1])])))));
        }
        pr_5 = (pr_4.then((result_3) => Result_MapError(testRedirect, result_3)));
        pr_5.then((_arg_5) => {
            if (_arg_5.tag === 0) {
                patternInput_5[1](_arg_5.fields[0]);
            }
            else {
                console.error(some("Failed fetching customer info"), _arg_5.fields[0]);
            }
        });
    });
    const ordersList = MuiHelpers_createElement(List, [["style", {
        maxHeight: isBig ? (60 + "vh") : (50 + "vh"),
        overflowY: "auto",
    }], (elements_2 = [map_1((o_1) => {
        let elements_1, elements;
        const isSelected = defaultArg(map((so) => (so.Id === o_1.Id), selectedOrder), false);
        return MuiHelpers_createElement(ListItem, [["key", o_1.Id], ["onClick", (_arg_6) => {
            setSelectedOrder(isSelected ? undefined : o_1);
        }], ["selected", isSelected], ["button", true], (elements_1 = [MuiHelpers_createElement(ListItemIcon, [["classes.alignItemsFlexStart", "flex-end"], (elements = toList(delay(() => {
            let props_1, props_3, props_5;
            return o_1.Complete ? singleton((props_1 = {}, react.createElement(Check, props_1))) : (o_1.Cancelled ? singleton((props_3 = {}, react.createElement(Clear, props_3))) : singleton((props_5 = {}, react.createElement(Sync, props_5))));
        })), ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(ListItemText, [["primary", `${toShortDateString(o_1.Ordered)}`], ["secondaryTypographyProps", {
            style: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            },
        }], ["secondary", `${ctx.Locale.t("By")} ${o_1.Account.Email}`]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
    }, sortByDescending((o) => o.Ordered, orders, {
        Compare: compare,
    }))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    return createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["justifyContent", "flex-start"]), delay(() => append(isBig ? append(singleton(["flexDirection", "row"]), delay(() => singleton(["alignItems", "flex-start"]))) : append(singleton(["flexDirection", "column"]), delay(() => singleton(["alignItems", "center"]))), delay(() => append(singleton(["width", 100 + "%"]), delay(() => singleton(["gap", 40 + "px"]))))))))))))], (elems_7 = toList(delay(() => {
        let elems_4;
        return loading ? append(singleton(MuiHelpers_createElement(Skeleton, toList(delay(() => append(isBig ? append(singleton(["height", 100 + "%"]), delay(() => singleton(["width", 20 + "%"]))) : append(singleton(["height", 20 + "%"]), delay(() => singleton(["width", 100 + "%"]))), delay(() => singleton(["variant", "rectangular"]))))))), delay(() => append(singleton(MuiHelpers_createElement(Skeleton, toList(delay(() => append(singleton(["style", {
            marginLeft: 2 + "ch",
            marginRight: 2 + "ch",
        }]), delay(() => append(isBig ? append(singleton(["height", 100 + "%"]), delay(() => singleton(["width", 2 + "%"]))) : append(singleton(["height", 2 + "%"]), delay(() => singleton(["width", 100 + "%"]))), delay(() => singleton(["variant", "rectangular"]))))))))), delay(() => singleton(MuiHelpers_createElement(Skeleton, toList(delay(() => append(isBig ? append(singleton(["height", 100 + "%"]), delay(() => singleton(["width", 75 + "%"]))) : append(singleton(["height", 75 + "%"]), delay(() => singleton(["width", 100 + "%"]))), delay(() => singleton(["variant", "rectangular"]))))))))))) : append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexShrink: 1,
            padding: 15 + "px",
            border: ((((1 + "px") + " ") + "solid") + " ") + "var(--grey)",
            borderRadius: 20 + "px",
        }], (elems_4 = toList(delay(() => {
            let elems_3;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems_3 = [MuiHelpers_createElement(Typography, [["variant", "h5"], ["children", ctx.Locale.t("SparePart.OrderHistory")]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => ((orders.length === 0) ? singleton(MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", (orders.length === 0) ? ctx.Locale.t("SparePart.NoPreviousOrders") : ctx.Locale.t("SparePart.PreviousOrders")]])) : singleton(ordersList))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
            let elems_6;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                gap: 15 + "px",
                width: 100 + "%",
                height: 100 + "%",
            }], (elems_6 = toList(delay(() => {
                if (selectedOrder != null) {
                    const order = selectedOrder;
                    return append(singleton(MuiHelpers_createElement(Button, [["variant", "contained"], ["size", "small"], ["style", {
                        alignSelf: "flex-start",
                    }], ["onClick", (_arg_7) => {
                        setSelectedOrder(undefined);
                    }], ["children", ctx.Locale.t("Back")]])), delay(() => {
                        let elems_5;
                        return singleton(createElement("div", createObj(singleton_1((elems_5 = [printOrder(ctx.Locale, value_133(customerOpt), order)], ["children", reactApi.Children.toArray(Array.from(elems_5))])))));
                    }));
                }
                else {
                    return singleton(createElement(CreateOrderView, {
                        account: value_133(accountOpt),
                        customerInfo: value_133(customerOpt),
                        machineInfo: machineInfo,
                        orders: orders,
                        setOrders: setOrders,
                    }));
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

